import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { AudioCaptureActions } from "@/components/note/floating-actions/AudioCaptureActions";
import { CleanUpActions } from "@/components/note/floating-actions/CleanUpActions";

interface VoiceActionsProps {
  editorStore: MemCommonEditorStore;
  onRequestClose?: () => void;
}

export const VoiceActions = observer<VoiceActionsProps>(function VoiceActions({
  editorStore,
  onRequestClose,
}) {
  const { store } = useAppStore();

  const noteId = editorStore.noteObservable?.id;

  if (store.audioCapture.activeNoteId === noteId) {
    return <AudioCaptureActions noteId={noteId} onRequestClose={onRequestClose} />;
  }

  return <CleanUpActions editorStore={editorStore} />;
});
